<!-- Modal Principal - Visualização do Cliente -->
<!-- Mobile: Bottom Sheet -->
@if (deviceService.$isMobile()) {
<lib-bottom-sheet
  [(visible)]="visible"
  size="full"
  [draggable]="true"
  [closeOnBackdrop]="true"
  [closeOnEscape]="true"
  [headerTemplate]="headerTemplateView"
  [footerTemplate]="
    activeTab() !== 'view' ? footerTemplate ?? undefined : undefined
  "
  (hide)="fechar()"
>
  @if ($internalVisible()) {
  <ng-container *ngTemplateOutlet="conteudoView"></ng-container>
  }
</lib-bottom-sheet>
} @else {
<!-- Desktop: Dialog -->
<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '520px', maxWidth: '95vw' }"
  (onHide)="fechar()"
>
  <ng-template pTemplate="header">
    <ng-container *ngTemplateOutlet="headerTemplateView"></ng-container>
  </ng-template>

  @if ($internalVisible()) {
  <ng-container *ngTemplateOutlet="conteudoView"></ng-container>
  }

  <ng-template pTemplate="footer">
    @if (activeTab() === 'criar' || activeTab() === 'editar') {
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    }
  </ng-template>
</p-dialog>

}

<!-- Template de header -->
<ng-template #headerTemplateView>
  <div class="w-full">
    <div
      class="pr-1 pl-1 pb-2 pt-2 border-round-lg lg:col-12 n-header-gradient"
    >
      <div class="n-header-content">
        <div class="sm:col-12 md:col-8">
          <span class="n-header-title text-white font-bold">
            @if (activeTab() === 'criar') {
            <i class="pi pi-user-plus mr-2"></i>
            {{ 'BARDO_CLIENTES.NOVO' | translate: { termo: $nicho().cliente.singular } }} } @else if (activeTab() === 'editar') {
            <i class="pi pi-pencil mr-2"></i>
            {{ 'BARDO_CLIENTES.EDITAR' | translate: { termo: $nicho().cliente.singular } }} } @else if (activeTab() === 'vinculos') {
            <i class="pi pi-users mr-2"></i>
            {{ 'BARDO_CLIENTES.VINCULOS.TITULO' | translate }} } @else {
            <i class="pi pi-user mr-2"></i>
            {{ 'BARDO_CLIENTES.FICHA_DE' | translate: { termo: $nicho().cliente.singular } }} }
          </span>

        </div>
        <div class="sm:col-12 md:col-4 flex justify-content-end gap-2">
          @if (!deviceService.$isMobile()) {
          <button
            type="button"
            class="n-close-btn"
            (click)="fechar()"
            [attr.aria-label]="'GLOBAL.FECHAR' | translate"
          >
            <i class="pi pi-times"></i>
          </button>
          }
        </div>
      </div>
    </div>
    @if (cliente !== null) {
    <div class="lg:col-12 n-tabs-container">
      <p-tabs [value]="activeTab()" (valueChange)="onTabChange($event)" libTabsInkbarFix>
        <p-tablist class="n-tablist-scroll">
          @for (tab of tabs; track tab.id) { @if (tabVisivel(tab.id)) {
          <p-tab [value]="tab.id" class="flex items-center !gap-2 text-inherit n-tab-item">
            <i [class]="tab.icon"></i>
            <span>{{ tab.labelKey | translate }}</span>
          </p-tab>
          } }
        </p-tablist>
      </p-tabs>
    </div>
    }

  </div>
</ng-template>

<!-- Template de conteúdo compartilhado -->
<ng-template #conteudoView>
  @switch (activeTab()) { @case ('view') { @if (cliente) {
  <lib-cliente-info [cliente]="cliente" (closed)="fechar()" />
  } } @case ('vinculos') { @if (cliente) {
  <lib-cliente-vinculos
    [cliente]="cliente"
    (vinculoAlterado)="onVinculoAlterado()"
  />
  } }
 @case ('editar') { @if (cliente) {
  <lib-cliente-create-edit
    [cliente]="cliente"
    (footerTemplateAction)="footerTemplateAction($event)"
    (saved)="onSaved()"
    (closed)="fecharAbaCriarEditar()"
  />
  } } @case ('criar') {
  <lib-cliente-create-edit
    (footerTemplateAction)="footerTemplateAction($event)"
    (saved)="onSaved()"
    (closed)="fecharAbaCriarEditar()"
  />
  } }
</ng-template>


